import { motion } from "framer-motion";
import { useState } from "react";
import { SERVICES, revealUp } from "../../lib/mrs";

export const Services = () => {
  const [hovered, setHovered] = useState(null);

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#121412] py-24 md:py-32 lg:py-40 border-y border-[#eae7e0]/10"
    >
      <div className="px-6 md:px-12 lg:px-20 mb-14 md:mb-20">
        <motion.p
          variants={revealUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#b89b72] mb-5"
        >
          What We Build For You
        </motion.p>
      </div>

      <div
        className="border-t border-[#eae7e0]/10"
        onMouseLeave={() => setHovered(null)}
      >
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.no}
            variants={revealUp}
            custom={i}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-40px" }}
            onMouseEnter={() => setHovered(i)}
            data-testid={`service-row-${i}`}
            className={`group relative border-b border-[#eae7e0]/10 px-6 md:px-12 lg:px-20 py-8 md:py-10 transition-colors duration-500 ${
              hovered !== null && hovered !== i ? "opacity-40" : "opacity-100"
            }`}
          >
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              <div className="flex items-baseline gap-6 md:gap-10">
                <span className="font-num text-xs md:text-sm tracking-[0.2em] text-[#b89b72] pt-1">
                  {s.no}
                </span>
                <h3 className="font-display font-light text-[#eae7e0] text-3xl md:text-5xl lg:text-6xl tracking-tight transition-transform duration-500 group-hover:translate-x-2">
                  {s.title}
                </h3>
              </div>
              <p className="text-sm md:text-base text-[#9ca399] max-w-sm md:text-right leading-relaxed pl-12 md:pl-0">
                {s.desc}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
